export default function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-router-dom/~/@babel/runtime/helpers/esm/extends.js
// module id = 1463
// module chunks = 4 5 11 15